export const colors = {
  bgPrimary: "#020617",
  bgSecondary: "#0f172a",
  bgElevated: "#1e293b",

  textPrimary: "#e2e8f0",
  textSecondary: "rgba(226,232,240,0.7)",

  accent: "#3b82f6",
  success: "#22c55e",
  warning: "#f59e0b",
  danger: "#ef4444",

  border: "rgba(148,163,184,0.5)",
  borderSubtle: "rgba(148,163,184,0.25)"
};
